<!-- Tast -->
<app-pco-toast></app-pco-toast>
<!-- Content -->
<router-outlet></router-outlet>
<!-- Dialogs -->
<p-confirmDialog key="level1" />
<p-confirmDialog key="level2" />

<!-- Global loading -->
@if (!!(loading.status$ | async)) {
  <div class="http-loading" style="z-index: 10000">
    <img alt=" " src="/assets/img/loader.gif" />
  </div>
}
